<template>
<header class="bg-white shadow-lg h-16 hidden md:flex">
  <nav class="header-links contents font-semibold text-sm lg:text-base">
    <ul class="flex items-center ml-4 xl:ml-8 mr-auto gap-x-4">
        <li :class="state.activeNav=='dashboard'?'active':''">
            <router-link :to="{name: 'Dashboard'}" class="w-full"  @click="state.activeNav='dashboard'">
                <span>Dashboard</span>
            </router-link>
        </li>
        <li class="relative parent z-20" :class="state.activeNav=='administration'?'active':''" v-if="(state.isAdministrator || state.isManagement || adminPermission()) && !functions.hasPermission('nuh.support', profile)">
            <button class="font-semibold text-sm lg:text-base flex justify-between md:inline-flex items-center hover:bg-gray-50">
                <span>Administration</span>
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 fill-current pt-1" viewBox="0 0 24 24"><path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z"/></svg>
            </button>
            <ul class="child transition duration-300 md:absolute top-full right-0 md:w-48 bg-gray-100 md:shadow-lg md:rounded-b ">
                <li><sidebar-router sidebar-link="ClientList" sidebar-name="Client"  @click="state.activeNav='administration'" v-if="state.isAdministrator || state.isManagement || getUserPermissions('client')" /></li>
                <li><sidebar-router sidebar-link="HospitalList" sidebar-name="Hospital"  @click="state.activeNav='administration'" v-if="state.isAdministrator || state.isManagement || getUserPermissions('hospital')"/></li>
                <li><sidebar-router sidebar-link="UserList" sidebar-name="User"  @click="state.activeNav='administration'" v-if="state.isAdministrator || state.isManagement || getUserPermissions('user')"/></li>
                <li><sidebar-router sidebar-link="GroupList" sidebar-name="Group"  @click="state.activeNav='administration'" v-if="state.isAdministrator || state.isManagement || getUserPermissions('group')"/></li>
                <li><sidebar-router sidebar-link="Holidays" sidebar-name="Holiday"  @click="state.activeNav='administration'" v-if="state.isAdministrator || state.isManagement || getUserPermissions('holiday')"/></li>
                <li><sidebar-router sidebar-link="Announcement" sidebar-name="Announcement"  @click="state.activeNav='administration'" v-if="state.isAdministrator || state.isManagement || getUserPermissions('announcement')" /></li>
                <li><sidebar-router sidebar-link="StaffMonitoring" sidebar-name="Staff Monitoring"  @click="state.activeNav='administration'" v-if="state.isAdministrator || state.isManagement" /></li>
                <li><sidebar-router sidebar-link="BESR" sidebar-name="BESR"  @click="state.activeNav='administration'" v-if="state.isAdministrator || state.isManagement" /></li>
            </ul>
        </li>
        <li class="relative parent z-20" :class="state.activeNav=='monitoring'?'active':''" v-if="state.isAdministrator || state.isManagement || getUserPermissions('monitoring')">
            <button class="font-semibold text-sm lg:text-base flex justify-between md:inline-flex items-center hover:bg-gray-50">
                <span>Monitoring</span>
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 fill-current pt-1" viewBox="0 0 24 24"><path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z"/></svg>
            </button>
            <ul class="p-2 child transition duration-300 md:absolute top-full right-0 md:w-48 bg-gray-100 md:shadow-lg md:rounded-b ">
                <li  class="xl:p-4">
                    <input type="text" placeholder="Search Client" class="form-input" v-model="state.keyword" @keyup="delaySearch(fetchClients)">
                </li>
                <li  class="xl:p-4" v-if="state.loadClients">
                    <div class="mt-2 mb-2 animate-pulse flex justify-center items-center">Searching... </div>
                </li>
                <li v-else id="style-7" class="h-40 overflow-y-auto">
                    <div v-for="client in state.clients" :key="client.id">
                        <router-link :to="{ name: 'MonitoringList', params : { id: client.id, tab: tab }}"  @click="state.activeNav='monitoring'"  class="flex py-1 justify-start items-center  focus:bg-gray-400 focus:text-blue-700 hover:bg-gray-400 rounded px-2 text-sm w-full md:w-52">
                                <button class="focus:outline-none uppercase p-2"><p class="break-all text-left">{{ client.name }}</p></button>
                        </router-link>
                    </div>   
                </li>
            </ul>
        </li>
        <li 
            class="relative parent z-20" 
            :class="state.activeNav=='workspace'?'active':''" 
            v-if="functions.hasRole(['Editor', 'Typist', 'QA', 'Uploader', 'Auditor', 'Administrator'], profile) || functions.hasPermission(['uploader.admin'], profile)">
            <button class="font-semibold text-sm lg:text-base flex justify-between md:inline-flex items-center hover:bg-gray-50">
                <span>Workspace</span>
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 fill-current pt-1" viewBox="0 0 24 24"><path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z"/></svg>
            </button>
            <ul class="child transition duration-300 md:absolute top-full right-0 md:w-48 bg-gray-100 md:shadow-lg md:rounded-b ">
                <li v-if="state.isTypist"><sidebar-router sidebar-link="WorkspaceTypist" sidebar-name="Typist"   @click="state.activeNav='workspace'" /></li>
                <li v-if="state.isQA || functions.hasRole('Editor', profile)"><sidebar-router sidebar-link="WorkspaceEditor" sidebar-name="Editor"   @click="state.activeNav='workspace'" /></li>
                <li v-if="state.isQA && !functions.hasPermission('nuh.support', profile)"><sidebar-router sidebar-link="WorkspaceQA" sidebar-name="QA"   @click="state.activeNav='workspace'" /></li>
                <li v-if="(functions.hasRole('Administrator', profile) || functions.hasRole('Management', profile) || functions.hasRole('Auditor', profile) ) && !functions.hasPermission('nuh.support', profile)"><sidebar-router sidebar-link="WorkspaceAudit" sidebar-name="Audit (QA)"   @click="state.activeNav='workspace'" /></li>
                <li v-if="(functions.hasRole('Administrator', profile) || functions.hasRole('Management', profile) || functions.hasRole('Uploader', profile) ) && !functions.hasPermission('nuh.support', profile) ||functions.hasPermission(['uploader.admin'], profile)"><sidebar-router sidebar-link="WorkspaceUploader" sidebar-name="Uploader"   @click="state.activeNav='workspace'" /></li>
            </ul>
        </li>
        <li class="relative parent z-20" :class="state.activeNav=='qass'?'active':''" v-if="state.isAdministrator || functions.hasRole('Auditor', profile) || functions.hasPermission('auditors.view', profile) ">
            <button class="font-semibold text-sm lg:text-base flex justify-between md:inline-flex items-center hover:bg-gray-50">
                <span>QASS</span>
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 fill-current pt-1" viewBox="0 0 24 24"><path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z"/></svg>
            </button>
            <ul class="child transition duration-300 md:absolute top-full right-0 md:w-48 bg-gray-100 md:shadow-lg md:rounded-b ">
                <li><sidebar-router sidebar-link="SavedList" sidebar-name="Saved List"   @click="state.activeNav='qass'" /></li>
                <li><sidebar-router sidebar-link="WorkspaceAuditor" sidebar-name="Audited Files"   @click="state.activeNav='qass'" /></li>
                <li v-if="functions.hasPermission('auditors.view', profile)"><sidebar-router sidebar-link="WorkspaceMasterAuditor" sidebar-name="Auditors"   @click="state.activeNav='qass'" /></li>
            </ul>
        </li>
        <li class="relative parent z-20" :class="state.activeNav=='reports'?'active':''"  >
            <button class="font-semibold text-sm lg:text-base flex justify-between md:inline-flex items-center hover:bg-gray-50">
                <span>Reports</span>
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 fill-current pt-1" viewBox="0 0 24 24"><path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z"/></svg>
            </button>
            <ul class="child transition duration-300 md:absolute top-full right-0 md:w-48 bg-gray-100 md:shadow-lg md:rounded-b ">
                <li><sidebar-router sidebar-link="ReportInvoice" sidebar-name="Invoice"  @click="state.activeNav='reports'" /></li>
                <li v-if="state.isAdministrator || state.isManagement"><sidebar-router sidebar-link="DailyReport" sidebar-name="Daily Report"  @click="state.activeNav='reports'" /></li>
                <li v-if="state.isAdministrator || state.isManagement">
                    <a :href="powerBiLink" target="_blank" class="w-full font-normal text-sm flex px-4 py-3 hover:bg-gray-400">Master Report</a>
                </li>
                <li><sidebar-router sidebar-link="DownloadList" sidebar-name="My Downloads"  @click="state.activeNav='reports'" /></li>
            </ul>
        </li>
        <!-- <li class="relative parent z-20" :class="state.activeNav=='besr'?'active':''" v-if="functions.hasRole('SR_Trainer', profile)" >
            <button class="font-semibold text-sm lg:text-base flex justify-between md:inline-flex  items-center hover:bg-gray-50">
                <span>BESR</span>
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 fill-current pt-1" viewBox="0 0 24 24"><path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z"/></svg>
            </button>
            <ul class="child transition duration-300 md:absolute top-full right-0 md:w-48 bg-gray-100 md:shadow-lg md:rounded-b ">
                <li><sidebar-router sidebar-link="TrainingList" sidebar-name="Training List"  @click="state.activeNav='besr'" /></li>
                <li><sidebar-router sidebar-link="TrainingScore" sidebar-name="Training Score"  @click="state.activeNav='besr'" /></li>
            </ul>
        </li> -->
        <li :class="state.activeNav=='jobsearch'?'active':''">
            <router-link :to="{name: 'JobSearch'}" class="w-full" @click="state.activeNav='jobsearch'">
                <span>Job Search</span>
            </router-link>
        </li>
        <li  class="relative parent z-20"  :class="state.activeNav=='ticket'?'active':''">
            <div class="w-full cursor-pointer" @click="state.activeNav='ticket';state.showTicket = true">
                <span>Links</span>
            </div>
        </li>
    </ul>
</nav>

  <div class="border flex items-center">
    <input v-if="functions.hasRole('Administrator', profile) || functions.hasRole('Management', profile) || functions.hasRole('Support', profile) || functions.hasRole('Auditor', profile)" id="search" v-model="state.searchID" v-on:keyup.enter="onEnter()" placeholder="Search..." type="text" class="w-fit px-3 py-2 transition ease-in-out border border-gray-300 border-solid rounded-md focus:text-gray-700 focus:bg-white focus:border-blue-900 focus:outline-none text-sm"  autocomplete="off"/>

    <div class="flex p-2">
        <span class="font-semibold flex mr-1 ">Total Line Count:</span> 
         <div class="text-xs leading-none text-center whitespace-nowrap align-baseline font-bold bg-blue-700 p-2 text-white rounded-full z-10">{{ Math.round(state.total_line_count * 100) / 100}}</div>
    </div>
    <!-- <a href="" class="mr-4 lg:mr-6 xl:mr-8">
      <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="search" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="h-6 xl:h-8 svg-inline--fa fa-search fa-w-16 fa-3x"><path fill="currentColor" d="M508.5 468.9L387.1 347.5c-2.3-2.3-5.3-3.5-8.5-3.5h-13.2c31.5-36.5 50.6-84 50.6-136C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c52 0 99.5-19.1 136-50.6v13.2c0 3.2 1.3 6.2 3.5 8.5l121.4 121.4c4.7 4.7 12.3 4.7 17 0l22.6-22.6c4.7-4.7 4.7-12.3 0-17zM208 368c-88.4 0-160-71.6-160-160S119.6 48 208 48s160 71.6 160 160-71.6 160-160 160z"></path></svg>
    </a> -->
    <template v-if="typeof store.getters['auth/userProfile'].permissions !=='undefined'">
        <template v-if="store.getters['auth/userProfile'].permissions.findIndex(d => d.name == 'Timetracker') === -1">
            <div class="text-sm mr-2 flex bg-gray-300 text-blue-dark font-semibold border-solid py-1 px-1 border border-blue rounded" title="start tracker">
                <span>Start Tracker</span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 8V13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12 22C7.17 22 3.25 18.08 3.25 13.25C3.25 8.42 7.17 4.5 12 4.5C16.83 4.5 20.75 8.42 20.75 13.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9 2H15" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M14.9004 18.5V17.34C14.9004 15.91 15.9204 15.32 17.1604 16.04L18.1604 16.62L19.1604 17.2C20.4004 17.92 20.4004 19.09 19.1604 19.81L18.1604 20.39L17.1604 20.97C15.9204 21.69 14.9004 21.1 14.9004 19.67V18.5Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div class="text-sm flex bg-gray-300 text-blue-dark font-semibold border-solid py-1 px-1 border border-blue rounded" title="end tracker">
                <span>End Tracker</span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="hover:animate-pulse ">
                    <path d="M12 22C7.17 22 3.25 18.08 3.25 13.25C3.25 8.42 7.17 4.5 12 4.5C16.83 4.5 20.75 8.42 20.75 13.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12 8V13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9 2H15" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M19 17V21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M16 17V21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </template>
        <template v-else>
            <button @keydown="handleKeybind" @click="timeTrackerModal" class="text-sm mr-2 flex bg-transparent hover:bg-blue text-blue-dark font-semibold hover:text-blue-800 py-1 px-1 border border-blue hover:border-blue-800 rounded" title="start tracker">
                <span>Start Tracker</span>
                <svg v-if="state.submitTracker" class="animate-spin h-4 w-4 mr-2" viewBox="0 0 24 24"><path fill="currentColor" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" /></svg>
                <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 8V13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12 22C7.17 22 3.25 18.08 3.25 13.25C3.25 8.42 7.17 4.5 12 4.5C16.83 4.5 20.75 8.42 20.75 13.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9 2H15" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M14.9004 18.5V17.34C14.9004 15.91 15.9204 15.32 17.1604 16.04L18.1604 16.62L19.1604 17.2C20.4004 17.92 20.4004 19.09 19.1604 19.81L18.1604 20.39L17.1604 20.97C15.9204 21.69 14.9004 21.1 14.9004 19.67V18.5Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <button @keydown="handleKeybind" @click="toggleTracker" class="text-sm flex bg-transparent hover:bg-blue text-blue-dark font-semibold hover:text-blue-800 py-1 px-1 border border-blue hover:border-blue-800 rounded" title="end tracker">
                <span>End Tracker</span>
                <svg v-if="state.endTracker || state.togglingTracker" class="animate-spin h-4 w-4 mr-2" viewBox="0 0 24 24"><path fill="currentColor" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" /></svg>
                <svg v-else
                 width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="hover:animate-pulse ">
                    <path d="M12 22C7.17 22 3.25 18.08 3.25 13.25C3.25 8.42 7.17 4.5 12 4.5C16.83 4.5 20.75 8.42 20.75 13.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12 8V13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9 2H15" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M19 17V21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M16 17V21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </template>
        <ul>
            <li class="relative parent z-20">
                <div class="m-2 inline-flex relative w-fit">
                    <!-- <div class="absolute inline-block top-0 right-0 bottom-auto left-auto translate-x-2/4 -translate-y-1/2 rotate-0 skew-x-0 skew-y-0 scale-x-100 scale-y-100 py-1 px-2.5 text-xs leading-none text-center whitespace-nowrap align-baseline font-bold bg-red-700 p-1 text-white rounded-full z-10">3</div> -->
                    <button class="flex gap-1 justify-between md:inline-flex p-2 items-center hover:bg-gray-50 font-semibold">
                        <!-- <svg class="h-5 xl:h-8 cursor-pointer"  viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.39999 19.1999C5.86116 18.6834 8.02104 16.3066 8.654 16.3066H15.3464C16.2636 16.3066 18.136 18.2768 18.6 18.9713M21.6 11.9999C21.6 17.3018 17.3019 21.5999 12 21.5999C6.69806 21.5999 2.39999 17.3018 2.39999 11.9999C2.39999 6.69797 6.69806 2.3999 12 2.3999C17.3019 2.3999 21.6 6.69797 21.6 11.9999ZM15.4388 8.72786C15.4388 6.89635 13.8927 5.3999 12.0003 5.3999C10.1079 5.3999 8.56173 6.89635 8.56173 8.72786C8.56173 10.5594 10.1079 12.0558 12.0003 12.0558C13.8927 12.0558 15.4388 10.5594 15.4388 8.72786Z" stroke="black" stroke-width="1.5"/>
                        </svg> -->
                        <h1 class="text-blue-700">{{ state.full_name }}</h1>
                        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 fill-current pt-1" viewBox="0 0 24 24"><path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z"/></svg>
                    </button>
                    <div class="absolute inline-block top-0 right-0 bottom-auto left-auto translate-x-2/4 -translate-y-1/2 rotate-0 skew-x-0 skew-y-0 scale-x-100 scale-y-100 py-1 px-2.5 text-xs leading-none text-center whitespace-nowrap align-baseline font-bold bg-red-700 p-1 text-white rounded-full z-10">{{ state.notificationCount + state.announcementCount }}</div>
                </div>
                <ul class="child transition duration-300 md:absolute top-full right-0 md:w-48 bg-gray-100 md:shadow-lg md:rounded-b ">
                    <li>
                        <router-link :to="{name:'JobsHistory'}" class="w-full font-normal text-sm flex px-4 py-3 hover:bg-gray-400">
                            Job History
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{name:'UserSettings'}" class="w-full font-normal text-sm flex px-4 py-3 hover:bg-gray-400">
                            Settings
                        </router-link>
                    </li>
                    <li>
                        <router-link  :to="{ name: 'Notifications'}">
                            <button  class="w-full font-normal text-sm flex px-4 py-3 hover:bg-gray-400"> Notifications <div class="ml-1 flex text-xs leading-none text-center whitespace-nowrap align-baseline font-bold bg-red-700 p-1 text-white rounded-full z-10">{{ state.notificationCount }}</div></button>
                        </router-link>
                    </li>
                    <li>
                        <router-link  :to="{ name: 'UserAnnouncements'}">
                            <button  class="w-full font-normal text-sm flex px-4 py-3 hover:bg-gray-400"> Announcements <div class="ml-1 flex text-xs leading-none text-center whitespace-nowrap align-baseline font-bold bg-red-700 p-1 text-white rounded-full z-10">{{ state.announcementCount }}</div></button>
                        </router-link>
                    </li>
                    <li>
                        <router-link  :to="{ name: 'DownloadList'}">
                            <button  class="w-full font-normal text-sm flex px-4 py-3 hover:bg-gray-400">Downloads</button>
                        </router-link>
                    </li>
                    <li>
                        <button @click="logoutUser" class="w-full font-normal text-sm flex px-4 py-3 hover:bg-gray-400">
                        Logout
                        </button>
                    </li>
                </ul>
            </li>
        </ul>
    </template>
  </div>
</header>

<!-- create modal -->
<Transition name="fade">
    <modal-component :open-modal="state.timeTrackerModal" v-on:change-modal="state.timeTrackerModal = false">
        <template v-slot:modal-body>
            <div class="flex flex-col w-full sm:flex sm:items-start">
                <div class="w-full my-2 text-center">
                    <h1 class="text-2xl font-semibold">Set Time Tracker</h1>
                </div>
                <form @submit.prevent="startTracker" class="w-full my-3 space-y-4 ">
                        <Label required="true" value="type" class="self-start " />
                        <div class="flex flex-row gap-4 justify-center">
                            <div class="flex flex-row gap-2 w-full relative items-center text-blue-700" v-for="item in types" :key="item">
                                    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="absolute left-0 w-5 h-5 ml-5" :class="item.name=='Productive'?'w-3 h-3':'w-5 h-5'" >
                                        <path :d="item.name === 'Break'? 'M11.9997 5.33366H12.6663C13.3736 5.33366 14.0519 5.61461 14.552 6.11471C15.0521 6.6148 15.333 7.29308 15.333 8.00033C15.333 8.70757 15.0521 9.38585 14.552 9.88594C14.0519 10.386 13.3736 10.667 12.6663 10.667H11.9997M11.9997 5.33366H1.33301V11.3337C1.33301 12.0409 1.61396 12.7192 2.11406 13.2193C2.61415 13.7194 3.29243 14.0003 3.99967 14.0003H9.33301C10.0403 14.0003 10.7185 13.7194 11.2186 13.2193C11.7187 12.7192 11.9997 12.0409 11.9997 11.3337V5.33366ZM3.99967 0.666992V2.66699M6.66634 0.666992V2.66699M9.33301 0.666992V2.66699': item.name=='Meeting'? 'M14 7.66669C14.0023 8.5466 13.7967 9.41461 13.4 10.2C12.9296 11.1412 12.2065 11.9328 11.3116 12.4862C10.4168 13.0396 9.3855 13.3329 8.33333 13.3334C7.45342 13.3356 6.58541 13.1301 5.8 12.7334L2 14L3.26667 10.2C2.86995 9.41461 2.66437 8.5466 2.66667 7.66669C2.66707 6.61452 2.96041 5.58325 3.51381 4.68839C4.06722 3.79352 4.85884 3.0704 5.8 2.60002C6.58541 2.20331 7.45342 1.99772 8.33333 2.00002H8.66667C10.0562 2.07668 11.3687 2.66319 12.3528 3.64726C13.3368 4.63132 13.9233 5.94379 14 7.33335V7.66669Z': ''" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    <input :id="item.name" type="checkbox" :value="item.value" v-model="state.timeTracker.type" @change="limitCheckbox(state.timeTracker.type)" class="hidden peer"/>
                                    <Label required="false" :for="item.name" :value="item.name" class="text-sm text-center capitalize p-2 w-full space-x-4 cursor-pointer border border-blue-700 border-solid rounded shape" :class="isChecked(state.timeTracker.type,item.value)? 'bg-blue-700 text-red-100 ':'text-blue-700 hover:bg-blue-700 hover:text-white hover:shadow'"/>                                    
                            </div>
                        </div>
                        <div v-if="state.error" class="text-xs italic text-red-600">{{ state.error.message }}</div>
                        <Label required="false" value="remarks"/>
                        <input type="text" v-model="state.timeTracker.remarks" id="tracker-remarks" class="w-full px-3 py-2 transition ease-in-out border border-gray-300 border-solid rounded-md focus:text-gray-700 focus:bg-white focus:border-blue-900 focus:outline-none">
                    </form>
            </div>
        </template>
        <template v-slot:action-button>
            <submit-button 
                id="startButton"
                type="button" 
                @click="startTracker" 
                button-text="Create" 
                button-color="blue"
                :on-submit="state.submitTracker" 
                class="flex justify-center w-full bg-blue-500 md:w-1/4 md:ml-3 lg:px-0"/>
        </template>
    </modal-component> 
</Transition>
<!-- ticket modal -->
<Transition name="fade">
     <div class="relative z-30" aria-labelledby="modal-title" role="dialog" aria-modal="true" v-if="state.showTicket">
        <div class="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"></div>

        <div class="fixed inset-0 z-10 overflow-y-auto">
            <div class="flex items-center justify-center min-h-full p-4 text-center sm:p-0">
                <div class="relative w-64 max-w-lg overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl">
                    <div class="px-3 pt-4 pb-3 bg-white sm:p-6 sm:pb-3">
                        <div class="flex flex-col  sm:flex sm:items-start z-20">
                            <div class="border-b-2 border-solid border-gray-300 w-full">
                                <span class="font-semibold  text-base">Site Links</span>
                            </div>
                            <div class="w-full mt-3 flex flex-col">
                                <a href="https://prescribeticket.zohodesk.com/portal/en/signin" target="_blank" class="text-blue-400 hover:text-blue-600 text-xl">Ticket</a>
                                <a href="https://wiki.prescribe-digital.com/prescribe/" target="_blank" class="text-blue-400 hover:text-blue-600 text-xl">PrescribeWIki</a>
                                <a v-if="state.isAdministrator || state.isManagement" href="https://app.powerbi.com/view?r=eyJrIjoiNGE2NTYyZTktMTNjZS00MGIyLTg4MjgtNDA1NjE4MjUxMTQ2IiwidCI6IjM2OTIzNGNmLTg1ZjEtNDEzYS05N2Q4LTY3MzFkNDA4MGRlOSIsImMiOjEwfQ%3D%3D" target="_blank" class="text-blue-400 hover:text-blue-600 text-xl">ISR</a><br>
                            </div>
                        </div>
                    </div>
                    
                    <div class="px-4 py-3 bg-gray-50 sm:flex sm:flex-row-reverse sm:px-6">
                        <button @click="state.showTicket=false" type="button" class="inline-flex justify-center w-full px-4 py-1 mt-3 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">Close</button>
                    </div>
                </div>
            </div>
        </div>
     
    </div>
</Transition>
<!-- notification modal -->
<Transition name="fade">
    <modal-component :open-modal="state.showNotification" v-on:change-modal="state.showNotification = false">
        <template v-slot:modal-body>
            <div class="flex flex-col w-full sm:flex sm:items-start z-20">
                <div class="border-b-2 border-solid border-gray-300 w-full">
                    <h1 class="text-2xl font-semibold uppercase">{{ state.notification.letter.reference + ' | ' + state.notification.owner.first_name + ' ' + state.notification.owner.last_name }}</h1>
                    <span class="font-semibold  text-sm">{{ functions.formatDateTime(state.notification.data.created_at)}}</span>
                </div>
                <div class="w-full my-2 text-justify ">
                    <span class="font-semibold text-base">{{ state.notification.data.remarks }}</span>
                    <p class="">Reference #: <span class="font-semibold text-sm">{{ state.notification.letter.reference }}</span></p>
                    <p>Priority: <span class="font-semibold text-sm uppercase">{{ state.notification.letter.priority }}</span></p>
                    <p>Created at: <span class="font-semibold text-sm">{{ functions.formatDateTime(state.notification.letter.author_created) }}</span></p>
                    <p>Organization: <span class="font-semibold text-sm">{{ state.notification.letter.organization }}</span></p>
                </div>
                    
            </div>
        </template>
    </modal-component> 
</Transition>
<!-- confirmation modal -->
<Transition name="fade">
            <modal-component :open-modal="state.confirmEndTrack" v-on:change-modal="state.confirmEndTrack = false">
                <template v-slot:modal-body>
                    <div class="flex flex-col w-full sm:flex sm:items-start z-20">
                        <div class="border-b-2 border-solid border-gray-300 w-full">
                            <h1 class="text-2xl font-semibold">Do you want to end the tracker?</h1>
                            <p class="font-semibold mb-5 text-base">Your line count for this letter will not be saved on your time tracker</p>
                            <span class="text-base">Note: Tracker will automatically end when you submit the letter.</span>
                        </div>
                    </div>
                </template>
                <template v-slot:action-button>
                    <submit-button
                        id="endtrackerButton"
                        type="button" 
                        @click="endTracker" 
                        button-text="Confirm" 
                        button-color="red"
                        :on-submit="state.endTracker" 
                        class="flex justify-center w-full bg-red-500 md:w-1/4 md:ml-3 lg:px-0"/>
                </template>
            </modal-component> 
</Transition>
</template>

<script setup>
import SidebarRouter from './SidebarRouter'
import router from '@/router';
import axios from '@/store/axios/axios';
import { useStore } from 'vuex';
import { reactive, watch, computed, onMounted, onBeforeUnmount,  ref, nextTick } from 'vue';
import { createToast } from 'mosha-vue-toastify';
import Label from '@/components/Label.vue';
import SubmitButton from '@/components/SubmitButton.vue';
import ModalComponent from '@/components/Modal.vue';
import functions from '@/assets/helpers/'

onMounted(()=> {
    document.addEventListener('keydown', handleKeybind)
})
onBeforeUnmount(()=> {
    document.removeEventListener('keydown', handleKeybind)
})
let state = reactive({
    user:{
        status: '',
        name:''
    },
    timeTracker:{
        type:[],
        remarks:''
    },
    notification:{
        data:'',
        letter:'',
        owner:''
    },
    searchID:'',
    full_name:'',
    notificationCount:0,
    users:[],
    statusModal: false, 
    timeTrackerModal:false,
    startTracker:false,
    endTracker:false,
    submitTracker:false,
    error:[],
    userProfile:'',
    admin:false,
    workspace:false,
    settings:false,
    reports:false,
    clients:[],
    keyword:'',
    activeNav:'',
    loadClients:false,
    isQA:false,
    isTypist:false,
    isEditor:false,
    isAdministrator:false,
    isManagement:false,
    isWorkspace:false,
    selectedJob:'',
    showNotification : false,
    showUnreadNotif:false,
    total_line_count:0,
    userPermissions:[],
    confirmEndTrack:false,
    announcementCount:0,
    showTicket:false,
    searchDelay: null,
    isLoaded : false,
    togglingTracker: false,
})


let types = [
    { name: 'Meeting', value:'meeting'},
    { name: 'Break', value:'non-productive'},
]
const startButton = ref(null)
const store = useStore()
// const notifInterval = setInterval(fetchNotifications, 60000)
state.activeNav = store.getters['auth/activeNav']
state.total_line_count = store.getters['auth/totalLineCount']
state.clients = store.getters['data/clientList']
let profile = store.getters['auth/userProfile']
state.userPermissions = profile.permissions
getProfile(profile)

watch(() => state.startButton , (newValue) => {
        nextTick(()=>{
            const startTracker = document.querySelector("input#tracker-remarks");
            startTracker.focus();
        })
})
watch(() => state.confirmEndTrack , (newValue) => {
        nextTick(()=>{
            const endButton = document.querySelector("#endtrackerButton")
            endButton.focus()
        })
})
watch(() => state.activeNav, (newValue) => {
    store.dispatch('auth/setAcitveNav',newValue)
    state.activeNav = store.getters['auth/activeNav']
    if(newValue ==='dashboard'){
        fetchLineCount()
    }
})
watch(() => store.getters['auth/totalLineCount'], (newValue) => {
    state.total_line_count = store.getters['auth/totalLineCount']
})
watch(() => store.getters['auth/userProfile'], (newValue) => {
    getProfile(newValue)
    state.userPermissions = newValue.permissions
})
watch(() => store.getters['data/clientList'], (newValue) => {
    state.clients = newValue
})
let tab = computed(() => {
  return functions.hasPermission('nuh.support', profile)? 'being_typed':'for_typing'
})
let powerBiLink = computed(() => {
  return window.navigator.userAgent.includes("Edg") ? 'https://app.powerbi.com/groups/me/reports/c8330231-9970-4ca6-9d09-8a1f2b70fe1f/ReportSection?experience=power-bi':'microsoft-edge:https://app.powerbi.com/groups/me/reports/c8330231-9970-4ca6-9d09-8a1f2b70fe1f/ReportSection?experience=power-bi'
})

function handleKeybind(event){
    if ((event.altKey && event.key === 's') && store.getters['auth/userProfile'].permissions.findIndex(d => d.name == 'Timetracker') !== -1) {
        event.preventDefault()
        timeTrackerModal()    
    } else if((event.altKey && event.key === 'e') && store.getters['auth/userProfile'].permissions.findIndex(d => d.name == 'Timetracker') !== -1){
        event.preventDefault()
        toggleTracker()    
    }
}
function delaySearch(method){
    clearTimeout(state.searchDelay)
    state.searchDelay = setTimeout(method, 500)
}
async function toggleTracker(){
    state.togglingTracker = true
    let trackers = []
    await axios.get(`/api/timetracker/`, {
        headers: { 'Authorization' : `Bearer ${localStorage.getItem('token')}` }
    })
    .then( response => {
        state.togglingTracker = false
        trackers = response.data.data
        if(trackers[trackers.length - 1]?.type == "PRODUCTIVE" && trackers[trackers.length - 1]?.out == null){
            state.confirmEndTrack = !state.confirmEndTrack
        } else endTracker()
    })
    .catch(error => {
        state.togglingTracker = false
    })
    
}
function getProfile(newValue){
    if(newValue !==''){
        if(newValue.roles.findIndex(d => d.name == 'Typist') !== -1 || newValue.roles.findIndex(d => d.name == 'Administrator') !== -1){
            state.isTypist = true
        }
        if(newValue.roles.findIndex(d => d.name == 'QA') !== -1 || newValue.roles.findIndex(d => d.name == 'Administrator') !== -1){
            state.isQA = true
        }
        if(newValue.roles.findIndex(d => d.name == 'Editor') !== -1 || newValue.roles.findIndex(d => d.name == 'Administrator') !== -1){
            state.isEditor = true
        }
        if(newValue.roles.findIndex(d => d.name == 'Administrator') !== -1){
            state.isAdministrator = true
        }
        if(newValue.roles.findIndex(d => d.name == 'Management') !== -1){
            state.isManagement = true
        }

        state.full_name = newValue.first_name + ' ' + newValue.last_name
    }
}
function getUserPermissions(action){
    if(state.userPermissions && state.userPermissions.length > 0 ){
        let permission = state.userPermissions.filter(item => item.code.includes(action))
        return (permission.length !== 0? true:false) 
    } else return false
}
function adminPermission(){
    let values = ['clients', 'users', 'group', 'announcement']
    if(state.userPermissions && state.userPermissions.length > 0){
        let permission = state.userPermissions
        let hasPermission = false
        for (let i = 0; i < values.length; i++) {
            permission = state.userPermissions.filter(item => item.code.includes(values[i]))
            permission.length !== 0? hasPermission = true: hasPermission = false
        } 
        return hasPermission
    } else return false
}
async function fetchClients(){
state.loadClients = true
    const params = { 
        status : 'active',
        keyword : state.keyword
    }
    await axios.get(`/api/clients`, {
        params,
        headers : { 'Authorization' : `Bearer ${localStorage.getItem('token')}`}
    })
    .then( response => {
        state.clients = response.data.data.data
        state.loadClients = false
    })
    .catch( error => {
        console.log(error)
        state.loadClients = false
    })
}

async function onEnter(){
    router.push({
        name:'GeneralSearch',
        params:{
            id:state.searchID
        }
    })
}

function timeTrackerModal(){
    state.timeTrackerModal = !state.timeTrackerModal
    state.startButton = !state.startButton
    state.timeTracker.type = []
    state.timeTracker.remarks=''
    state.error = ''

    if(window.location.href.includes('/workspace/typist/') || window.location.href.includes('/workspace/qa/') || window.location.href.includes('/workspace/edit/')){
        state.isWorkspace = true
        if(types.findIndex(d => d.name == 'Productive') == -1 ){
            types.push({ name: 'Productive', value:'productive'})
			state.timeTracker.type=['productive']
        }
        let value = ''
        if(window.location.href.includes('/workspace/typist/')){
            value= window.location.href.split('/workspace/typist/')[1]
            state.selectedJob = value.split('/')[1]
        }
        if(window.location.href.includes('/workspace/qa/')){
             value= window.location.href.split('/workspace/qa/')[1]
            state.selectedJob = value.split('/')[1]
        }
        if(window.location.href.includes('/workspace/edit/')){
            value=window.location.href.split('/workspace/edit/')[1]
            state.selectedJob = value.split('/')[1]
        }
    }else{
        let spliceIndex = types.findIndex(d => d.name == 'Productive')
        if(spliceIndex !== -1){
            let sliceType = types.splice(spliceIndex,1);
            types = types.filter(type => type.name!=='Productive')
        }
    }
	if(types.findIndex(d => d.name == 'Productive') !== -1){
        state.timeTracker.type=['productive']
    } else {
        state.timeTracker.type=['non-productive']
    }
}
function isChecked(data, value){
    return (data.map(item => item).includes(value))
}
function limitCheckbox(data){
    if(data.length > 1) data.shift()
}
async function startTracker(){
    state.submitTracker = true;
    let params = ''
    if(state.timeTracker.type[0]==='productive'){
        params = {
            jobId: state.selectedJob,
            type: state.timeTracker.type[0],
            remarks: state.timeTracker.remarks
        }
    }else{
        params = {
            type: state.timeTracker.type[0],
            remarks: state.timeTracker.remarks
        }
    }
    
    await axios.get(`/api/timetracker/start`, {
        params,
        headers: {'Authorization' : `Bearer ${localStorage.getItem('token')}`}
    })
    .then(response => {
        createToast(response.data.message,{
                showIcon: true,
                type: 'success',
        }); 
        state.submitTracker = false
        state.timeTrackerModal = !state.timeTrackerModal
        if(state.timeTracker.type[0]==='productive'){
            store.dispatch('auth/validateTracker',state.selectedJob)
        }
    })
    .catch(error => {
        if(error.response.status==400 || error.response.status==403) {
            state.timeTrackerModal = !state.timeTrackerModal
            createToast(error.response.data.message,{
                showIcon: true,
                type: 'warning',
            }); 
        } else if(error.response.status==422) {
            state.error = error.response.data
        }
        state.submitTracker = false
    })
}

async function endTracker(){
    state.endTracker = true;
    await axios.get(`/api/timetracker/end`, {
        headers: {'Authorization' : `Bearer ${localStorage.getItem('token')}`}
    })
    .then(response => {
        createToast(response.data.message,{
                showIcon: true,
                type: 'success',
        }); 
        state.endTracker = false
        fetchLineCount()
        state.confirmEndTrack = false
        if(state.timeTracker.type[0]==='productive'){
            store.dispatch('auth/validateTracker',state.selectedJob)
        }
    })
    .catch(error => {
        createToast(error.response.data.message,{
                showIcon: true,
                type: 'warning',
        }); 
        state.endTracker = false
        state.confirmEndTrack = false
    })
}

function toggleMenu(){
    var menu = document.getElementById('menu');
    
    menu.classList.toggle('hidden');
    menu.classList.toggle('w-full');
    menu.classList.toggle('h-screen');
      
}
function logoutUser (){
    store.dispatch('auth/LogOut')
}
// async function countUnseenAnnouncements(){
//     await axios.get(`/api/announcements/unseen`, {
//         headers: {'Authorization' : `Bearer ${localStorage.getItem('token')}`}
//     })
//     .then(response => {
//         state.announcementCount = response.data.unseen
//     }).catch(error => console.log(error))
// }
// countUnseenAnnouncements()
// async function fetchNotificationsCount(){
//     await axios.get(`/api/notifications/unseen`, {
//         headers: {'Authorization' : `Bearer ${localStorage.getItem('token')}`}
//     })
//     .then( response => {
//         state.notificationCount = response.data.data
//     })    
// }
async function fetchLineCount(){
    await axios.get(`/api/timetracker/`,{
        headers: {'Authorization' : `Bearer ${localStorage.getItem('token')}`}
    })
    .then( response => {
        state.total_line_count = response.data.total_linecount
        state.notificationCount = response.data.unseen_notification
        state.announcementCount = response.data.unseen_announcement
    })    
}
// fetchNotificationsCount()
fetchLineCount()

</script>

<style scoped>
    @media only screen and (min-width: 768px){
        .parent:hover .child {
            opacity:1;
            height:auto;
            overflow:none;
            transform: translateY(0);
        }
        .child {
            opacity:0;
            height:0;
            overflow:hidden;
            transform: translateY(-10%);
        }
        .container {
            max-height: 90vh;
            overflow-y: scroll;
        }
    }

    .header-links li span {
        position: relative;
        z-index: 0;
    }

    .header-links li span::before {
        content: '';
        position: absolute;
        z-index: -1;
        bottom: 2px;
        left: -4px;
        right: -4px;
        display: block;
        height: 6px;
    }

    .header-links li.active span::before {
        background-color: #fcae04;
    }

    .header-links li:not(.active):hover span::before {
        background-color: #ccc;
    }
    #style-7::-webkit-scrollbar-track
    {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
        background-color: #F5F5F5;
        border-radius: 10px;
    }

    #style-7::-webkit-scrollbar
    {
        width: 7px;
        background-color: #F5F5F5;
    }

    #style-7::-webkit-scrollbar-thumb
    {
        border-radius: 10px;
        background-image: -webkit-gradient(linear,
            left bottom,
            left top,
            color-stop(0.44, rgb(122,153,217)),
            color-stop(0.72, rgb(73,125,189)),
            color-stop(0.86, rgb(28,58,148)));
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s ease;
    }

    .fade-enter-from,
    .fade-leave-to {
        opacity: 0;
    }
</style>
